export function normalizeSubscriptionStatus(value = "") {
  return String(value || "").trim().toLowerCase();
}

export function hasInsiderAccess(profileOrSubscription = null, fallbackTier = "") {
  if (typeof profileOrSubscription === "string") {
    return hasInsiderAccess(null, profileOrSubscription || fallbackTier);
  }
  const source =
    profileOrSubscription?.subscriptionData && typeof profileOrSubscription.subscriptionData === "object"
      ? profileOrSubscription.subscriptionData
      : profileOrSubscription && typeof profileOrSubscription === "object"
        ? profileOrSubscription
        : {};
  const tier = normalizeSubscriptionStatus(source?.tier || fallbackTier);
  const status = normalizeSubscriptionStatus(source?.subscriptionStatus || source?.status || "");

  if (tier !== "insider") return false;
  return !status || status === "active";
}

export function isMemberExclusiveCapsule(capsule = {}) {
  return normalizeSubscriptionStatus(capsule?.capsuleType) === "memberexclusive";
}

export function shouldGateMemberExclusiveContent(capsule = {}, profileOrSubscription = null, fallbackTier = "") {
  return isMemberExclusiveCapsule(capsule) && !hasInsiderAccess(profileOrSubscription, fallbackTier);
}
